export function registerServiceWorker() {
 if ('serviceWorker' in navigator && import.meta.env.PROD) {
 window.addEventListener('load', () => {
 navigator.serviceWorker
 .register('/sw.js')
 .then((registration) => {
 console.log('SW registered:', registration.scope);

 // Check for updates periodically (every 30 min)
 setInterval(() => registration.update(), 30 * 60 * 1000);
 })
 .catch((err) => {
 console.log('SW registration failed:', err);
 });
 });
 }
}

/** Manually push report data into the SW cache */
export function cacheReportData(reportId: string, data: unknown) {
 if (!navigator.serviceWorker?.controller) return;

 navigator.serviceWorker.controller.postMessage({
 type: 'CACHE_REPORT',
 url: `/_cached_report/${reportId}`,
 data,
 });
}

/** Clear the report cache (e.g. on sign-out) */
export function clearReportCache() {
 if (!navigator.serviceWorker?.controller) return;

 // Clear report cache + all caches to prevent data leaks on sign-out
 navigator.serviceWorker.controller.postMessage({
 type: 'CLEAR_ALL_CACHES',
 });
}
